var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2893",
    "data-name": "Group 2893",
    transform: "translate(-528 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    transform: "translate(528 444)",
    fill: "none",
    stroke: "#0f0fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M13216.5,13341a39.381,39.381,0,1,1,15.375-3.1A39.24,39.24,0,0,1,13216.5,13341Zm10.624-39a8.616,8.616,0,0,1,5.069,1.415l.014.008a9.408,9.408,0,0,0,5.293,1.577,1.5,1.5,0,0,0,0-3,6.5,6.5,0,0,1-3.783-1.169,12.78,12.78,0,0,0-13.182,0,6.709,6.709,0,0,1-7.566,0,12.776,12.776,0,0,0-13.183,0,6.524,6.524,0,0,1-3.786,1.17,1.5,1.5,0,0,0,0,3,9.376,9.376,0,0,0,5.292-1.576,9.789,9.789,0,0,1,10.152-.01l.014.009a9.673,9.673,0,0,0,10.586,0l.009-.006A8.6,8.6,0,0,1,13227.124,13302Z",
    transform: "translate(-12636 -12805)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    transform: "translate(536 452)",
    fill: "none",
    stroke: "#0f0fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 43.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.c1ac906f7a9aa8c4f50035cb59a46357.svg";
export { ForwardRef as ReactComponent };